import { Injectable } from '@angular/core';
import { BrowserType } from '../enums/browser-type.enum';

@Injectable({
  providedIn: 'root',
})
export class BrowserTypeService {
  public getBrowserName(): BrowserType {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return BrowserType.Edge;
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return BrowserType.Opera;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return BrowserType.Chrome;
      case agent.indexOf('trident') > -1:
        return BrowserType.Ie;
      case agent.indexOf('firefox') > -1:
        return BrowserType.Firefox;
      case agent.indexOf('safari') > -1:
        return BrowserType.Safari;
      default:
        return BrowserType.Other;
    }
  }
}
